import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
export function Hero() {
  return <section id="inicio" className="relative h-screen w-full flex items-center justify-center overflow-hidden" data-id="element-145">
      <div className="absolute inset-0 z-0" data-id="element-146">
        <motion.img src="https://cdn.magicpatterns.com/uploads/usZogFJoDnYGKVJE9NX38g/Onyx__Steel_Banner.png" alt="Barbershop Banner" className="w-full h-full object-cover object-[72%_center] sm:object-center" initial={{
        scale: 1.1
      }} animate={{
        scale: 1
      }} transition={{
        duration: 10,
        ease: 'easeOut'
      }} data-id="element-147" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/40 to-[#1A1A1B]" data-id="element-148"></div>
      </div>

      <div className="relative z-10 container mx-auto px-6 flex flex-col items-center text-center mt-20" data-id="element-149">
        <motion.h1 className="font-serif text-5xl md:text-7xl lg:text-8xl tracking-[0.15em] mb-6 text-white" initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.2,
        ease: 'easeOut'
      }} data-id="element-150">
          ONYX & STEEL
        </motion.h1>
        <motion.p className="text-lg md:text-xl text-white/80 font-light tracking-[0.2em] uppercase mb-12 max-w-2xl" initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.4,
        ease: 'easeOut'
      }} data-id="element-151">
          Donde la Precisión se Convierte en Confianza
        </motion.p>
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.6,
        ease: 'easeOut'
      }} data-id="element-152">
          <a href="#contact" data-id="element-153">
            <Button data-id="element-154">Reserva Tu Experiencia</Button>
          </a>
        </motion.div>
      </div>
    </section>;
}